//--------------------------------
// load character equipped armour
//--------------------------------
export default function loadCharacterEquippedArmour({ character }) {
  console.log('-----------------------')
  console.log('IN loadCharacterEquippedArmour')
  /*
   want the headline armour location values for a given character item (equipped armour) 
   e.g. AP/HP, layer, coverage
  */

  //==================================================================
  // INTERNAL FUNCTION: find equipped armour entry by character item id
  //------------------------------------------------------------------
  function _findEquippedArmourByItemId(armourLocations, itemId, itemName = null) {
    if (!Array.isArray(armourLocations) || !itemId) return null

    // Prefer matching by character-item id (ea.armour). This avoids
    // conflicts when multiple items share the same name (e.g. two
    // Heavy Leather Greaves on different legs).
    let firstMatchById = null
    let matchedDexPenTotal = 0

    for (const loc of armourLocations) {
      const equipped = Array.isArray(loc.equipped_armour) ? loc.equipped_armour : []

      equipped.forEach((ea) => {
        if (!ea || ea.armour !== itemId) return

        if (firstMatchById === null) {
          firstMatchById = {
            layer: ea.layer ?? null,
            ap: ea.ap ?? null,
            hp: ea.hp ?? null,
            dex_pen_factor: ea.dex_pen_factor ?? null,
            dex_pen: ea.dex_pen ?? null,
            coverage: ea.coverage ?? null,
            armour_location_name: loc.armour_location_name ?? null,
          }
        }

        const matchDexPen = Number(ea.dex_pen)
        if (!Number.isNaN(matchDexPen)) {
          matchedDexPenTotal += matchDexPen
        }
      })
    }

    if (firstMatchById) {
      return {
        ...firstMatchById,
        dex_pen_total: matchedDexPenTotal,
      }
    }

    // Fallback: if armour field missing for older data, fall back to name
    if (itemName) {
      let firstMatchByName = null
      let totalByName = 0

      for (const loc of armourLocations) {
        const equipped = Array.isArray(loc.equipped_armour) ? loc.equipped_armour : []

        equipped.forEach((ea) => {
          if (!ea || ea.armour_name !== itemName) return

          if (firstMatchByName === null) {
            firstMatchByName = {
              layer: ea.layer ?? null,
              ap: ea.ap ?? null,
              hp: ea.hp ?? null,
              dex_pen_factor: ea.dex_pen_factor ?? null,
              dex_pen: ea.dex_pen ?? null,
              coverage: ea.coverage ?? null,
              armour_location_name: loc.armour_location_name ?? null,
            }
          }

          const dp = Number(ea.dex_pen)
          if (!Number.isNaN(dp)) {
            totalByName += dp
          }
        })
      }

      if (firstMatchByName) {
        return {
          ...firstMatchByName,
          dex_pen_total: totalByName,
        }
      }
    }

    return null
  }

  //==================================================================
  // MAIN FLOW
  //-----------
  // console.log('loadCharacterEquippedArmour character items = ', character.items)
  //-----------------------------------------------------
  // check for equipped armour on character armour/items
  //-----------------------------------------------------
  const equipped_items = character.items.filter((i) => i && i.equipped)
  console.log('equipped_items = ', equipped_items)
  if (!equipped_items || equipped_items.length === 0) {
    console.log('No equipped armour found on character.')
    return character
  }
  //-----------------------------------------------------------------------------------
  // loop equipped items & get armour details from matching character armour_locations
  //-----------------------------------------------------------------------------------
  equipped_items.forEach((ei) => {
    // console.log('Processing equipped item: ', ei.name)

    // find matching character armour location (if any) for this equipped item.
    // Use the character item id primarily to avoid clashes when multiple
    // items have the same name; fall back to name only if needed.
    const res = _findEquippedArmourByItemId(character.armour_locations, ei.id, ei.name)

    if (!res) {
      console.warn(`No matching equipped armour details found for item "${ei.name}".`)
    } else {
      // console.log(`Found equipped armour details for item "${ei.name}":`, res)
      // add these details to the item (for display on character sheet summary)
      ei.layer = res.layer
      ei.ap = res.ap
      ei.hp = res.hp
      ei.dex_pen_factor = res.dex_pen_factor
      if (res.dex_pen_total != null) {
        ei.dex_pen = res.dex_pen_total
      } else {
        ei.dex_pen = res.dex_pen
      }

      // Keep the item's specific armour_location_name when present (e.g.
      // "Lower Left Leg" / "Lower Right Leg"), falling back to the
      // character-armour-location name from res if needed.
      ei.armour_location_name = ei.armour_location_name || res.armour_location_name

      // For flexible/non-fixed armour, when an armour_location is set on
      // the item, prefer that specific location name for coverage; for
      // fixed armour fall back to the per-location coverage from res.
      if (ei.armour_location) {
        ei.coverage = ei.armour_location_name || res.coverage
      } else {
        ei.coverage = res.coverage
      }
    }
  })
  console.log('Finished processing equipped items. Updated character ', character)
  //-----------------------------------------------------
  //
  //-----------------------------------------------------
  return character
}
